import { render, staticRenderFns } from "./example_click_the_target.config.vue?vue&type=template&id=42aa92dd"
var script = {}


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports